import { graphql } from 'react-apollo';
import { itemRelatedVideos } from 'legacy/src/queries';

const withRelatedVideos = graphql(itemRelatedVideos, {
  options: ({ itemId, educationPeriod, masterSubjectId }) => ({
    variables: {
      itemId: Number.parseInt(itemId, 10),
      educationPeriod: Number.parseInt(educationPeriod, 10),
      masterSubjectId: Number.parseInt(masterSubjectId, 10),
    },
    fetchPolicy: 'network-only',
  }),
  props: ({ data }) => {
    const { loading: isLoadingRelatedVideos, relatedVideos, error } = data;
    const videos = error ? [] : (relatedVideos || {}).videos;

    return {
      isLoadingRelatedVideos,
      videos,
      error: error && error.message,
    };
  },
});

export default withRelatedVideos;
